import { CONFIG_VERSION, validateRuntimeConfig } from "~/utils/config-contract";
import { setRuntimeConfig } from "~/utils/runtime-config";

// Primer plugin (client) de la intranet: carga /config.json en runtime ANTES de que el
// resto arranque, inyecta $config, fija el baseURL de axios (C7: antes de que @nuxtjs/auth
// dispare su primera request) y publica el singleton para código no-Vue (rcp-08).
//
// Fallback = error de arranque VISIBLE (D5): si el fetch falla, tarda demasiado, el JSON
// es inválido o la versión de contrato no coincide (C3), la app NO monta con datos vacíos
// ni se queda en blanco: se pinta un error legible y se aborta el arranque.

const CONFIG_URL = "/config.json";
const FETCH_TIMEOUT_MS = 8000;

const renderStartupError = (detail) => {
	if (typeof document === "undefined") return;
	document.body.innerHTML = `
		<div role="alert" style="font-family:system-ui,sans-serif;max-width:32rem;margin:15vh auto;padding:1.5rem;border:1px solid #e74052;border-radius:8px;color:#333">
			<h1 style="font-size:1.1rem;margin:0 0 .5rem">No se pudo iniciar la aplicación</h1>
			<p style="margin:0 0 .5rem">Fallo al cargar la configuración (<code>/config.json</code>).</p>
			<p style="margin:0;color:#666;font-size:.85rem">${detail}</p>
		</div>`;
};

const fetchConfig = async () => {
	const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
	const timer = controller ? setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS) : null;
	try {
		const res = await fetch(CONFIG_URL, { cache: "no-store", signal: controller ? controller.signal : undefined });
		if (!res.ok) throw new Error(`HTTP ${res.status}`);
		return await res.json();
	} finally {
		if (timer) clearTimeout(timer);
	}
};

export default async function runtimeConfigPlugin(ctx, inject) {
	let config;
	try {
		config = await fetchConfig();
	} catch (err) {
		renderStartupError(`No se pudo obtener /config.json (${err.message}).`);
		throw err; // D5: abortar el arranque, no montar con datos vacíos
	}

	const result = validateRuntimeConfig(config, CONFIG_VERSION);
	if (!result.ok) {
		renderStartupError(result.reason);
		throw new Error(`config.json inválido: ${result.reason}`);
	}

	setRuntimeConfig(config);
	// $tenantConfig (no $config: Nuxt >=2.13 reserva $config para publicRuntimeConfig).
	inject("tenantConfig", config);

	// C7: baseURL aplicado antes de la primera request de auth.
	if (ctx.$axios && typeof ctx.$axios.setBaseURL === "function") {
		ctx.$axios.setBaseURL(config.api.url);
	}
}
